import React from 'react';
import { useFocused, useSelected, useSlateStatic } from 'slate-react'

import {removeLink} from '../../utils/link.js'
import unlink from '../../Toolbar/toolbarIcons/unlink.svg'
import './styles.css'
const Link = ({ attributes, element, children}) => {
    const editor = useSlateStatic();
    const selected = useSelected();
    const focused = useFocused();
    return (
        <span className='link' >
            <a
                href={element.href}
                {...attributes}
                target="_blank"
                rel="noopener noreferrer"
                onClick={(e) => {
                    e.preventDefault();
                    window.open(element.href, '_blank', 'noopener,noreferrer');
                }}
            >
                {children}
            </a>
            {selected && focused && (
                <div className='link-popup' contentEditable='false'>
                    <a href={element.href} target="_blank" rel="noopener noreferrer">{element.href}</a>
                    <button onClick={()=>removeLink(editor)}><img src={unlink} alt="" /></button>
                </div>
            )}
        </span>
    )
}

export default Link